import { render } from "./IndexList.vue?vue&type=template&id=d5dc7a36&scoped=true&ts=true"
import script from "./IndexList.vue?vue&type=script&lang=ts"
export * from "./IndexList.vue?vue&type=script&lang=ts"

import "./IndexList.vue?vue&type=style&index=0&id=d5dc7a36&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5dc7a36"]])

export default __exports__